export const usersRoles = {
  admin: 1,
  worker: 2,
  employer: 3
};

export const onboardingStatuses = {
  ACCOUNT_UNVERIFIED: 'account_unverified',
  ACCOUNT_VERIFIED: 'account_verified',
  ASSESSMENT_COMPLETED: 'assessment_completed',
  ASSESSMENT_FAILED: 'assessment_failed',
  INTERVIEW_REQUESTED: 'interview_requested',
  INTERVIEW_SCHEDULED: 'interview_scheduled',
  INTERVIEW_DECLINED: 'interview_declined',
  PAYLOCITY_PROGRESS: 'paylocity_progress',
  PAYLOCITY_COMPLETED: 'paylocity_completed',
  ONBOARD_COMPLETED: 'onboard_completed'
};

export const onboardingStatusesWithoutAsessment = {
  ACCOUNT_UNVERIFIED: 'account_unverified',
  ACCOUNT_VERIFIED: 'account_verified',
  INTERVIEW_REQUESTED: 'interview_requested',
  INTERVIEW_SCHEDULED: 'interview_scheduled',
  INTERVIEW_DECLINED: 'interview_declined',
  PAYLOCITY_PROGRESS: 'paylocity_progress',
  PAYLOCITY_COMPLETED: 'paylocity_completed',
  ONBOARD_COMPLETED: 'onboard_completed'
};

export const onboardingStatusesUsingOnboard = {
  APPLICATION_RECEIVED: 'application_received',
  APPLICATION_INREVIEW: 'application_inreview',
  APPLICATION_APPROVED: 'application_approved',
  APPLICATION_REJECTED: 'application_rejected',
  INTERVIEW_REQUESTED: 'interview_requested',
  INTERVIEW_SCHEDULED: 'interview_scheduled',
  INTERVIEW_DECLINED: 'interview_declined',
  PAYLOCITY_PROGRESS: 'paylocity_progress',
  PAYLOCITY_COMPLETED: 'paylocity_completed',
  ONBOARD_COMPLETED: 'onboard_completed'
};

export const onboardingStatusesUsingOnboardUi = [
  {
    id: onboardingStatusesUsingOnboard.APPLICATION_RECEIVED,
    value: 'Application Received'
  },
  {
    id: onboardingStatusesUsingOnboard.APPLICATION_INREVIEW,
    value: 'Application In-Progress'
  },
  {
    id: onboardingStatusesUsingOnboard.APPLICATION_APPROVED,
    value: 'Application Approved'
  },
  {
    id: onboardingStatusesUsingOnboard.APPLICATION_REJECTED,
    value: 'Application Declined'
  },
  {
    id: onboardingStatusesUsingOnboard.PAYLOCITY_PROGRESS,
    value: 'Paylocity In-Progress'
  },
  {
    id: onboardingStatusesUsingOnboard.PAYLOCITY_COMPLETED,
    value: 'Paylocity Completed'
  },
  {
    id: onboardingStatusesUsingOnboard.ONBOARD_COMPLETED,
    value: 'Onboard Completed'
  }
];

export const completedOnboardStatusesList = [
  onboardingStatuses.ONBOARD_COMPLETED
];

export const inprogressOnboardStatusesList = [
  onboardingStatuses.ACCOUNT_UNVERIFIED,
  onboardingStatuses.ACCOUNT_VERIFIED,
  onboardingStatuses.ASSESSMENT_COMPLETED,
  onboardingStatuses.ASSESSMENT_FAILED,
  onboardingStatuses.INTERVIEW_REQUESTED,
  onboardingStatuses.INTERVIEW_SCHEDULED,
  onboardingStatuses.INTERVIEW_DECLINED,
  onboardingStatuses.PAYLOCITY_PROGRESS,
  onboardingStatuses.PAYLOCITY_COMPLETED
];

export const backgroundStatuses = {
  IN_PROGRESS: 'in_progress',
  CONSIDER: 'consider',
  DECLINED: 'declined',
  COMPLETED: 'completed'
};

export const backgroundStatusesUi = [
  { id: backgroundStatuses.NOT_STARTED, value: 'Not Started' },
  { id: backgroundStatuses.IN_PROGRESS, value: 'In Progress' },
  { id: backgroundStatuses.CONSIDER, value: 'Consider' },
  { id: backgroundStatuses.DECLINED, value: 'Declined' },
  { id: backgroundStatuses.COMPLETED, value: 'Completed' }
];

export const JOBS_LIST_PAGE_SIZE = 20; // Default page size for jobs list
export const PAYROLL_RUNS_LIST_PAGE_SIZE = 20; // Default page size for payroll runs data
export const USERS_LIST_PAGE_SIZE = 20; // Default page size for tables with employers and workers lists
export const COMPANIES_LIST_PAGE_SIZE = 20; // Default page size for table with companies lists
export const CONVERSATIONS_LIST_PAGE_SIZE = 50; // Default page size for conversations lists

export const limitSearchUsersResults = 5;

export const adminAppLanguageId = 1;

export const phoneUSALength = 10;

export const zipCodeUSALength = 5;

export const dashboardDaysQuantity = 7;

export const basicRankingNumber = 1;

export const supportURL = 'support@gravy.work';

export const links = {
  termsAndConditions: 'http://gravy.work/mobile-app-terms-and-conditions',
  clientServiceAgreement: 'http://gravy.work/mobile-app-client-services-agreement',
  applicants: 'https://onboard.gravy.work/admin/applicants',
  candidates: 'https://onboard.gravy.work/admin/candidates',
  details: 'https://onboard.gravy.work/iframe',
};

export const gravyModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: 0
  }
};

export const genderList = [
  {
    code: 'M',
    label: 'Male'
  },
  {
    code: 'F',
    label: 'Female'
  }
];



// WEBPACK FOOTER //
// ./src/constants/general.js